'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarBannerSegmentText = renderWithRef('PriceBarBannerSegmentText', null, (t, n)=>{
    let { children: a } = t;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: new Set([
            'swan-price-bar-banner-text'
        ]),
        props: t,
        children: a
    });
});

export { PriceBarBannerSegmentText };
